﻿import $ from 'jquery';
import 'slick-carousel';

class ComparisonSliderItem {
    constructor(el, index) {
        this.render(el, index);       
    }
    render(el, i) {

        var $slider = $('.service_plan_block__results');

        var sliderSettings = {
            arrows: false,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            adaptiveHeight: true
        }
        if ($slider.length > 0) {
            this.trigger_slick_on_mobile($slider, sliderSettings, 959);
            
            if ($(window).width() > 959) {
                if ($slider.hasClass('slick-initialized')) {
                    $slider.slick('unslick');
                }
                return;
            }
            if (!$slider.hasClass('slick-initialized')) {
                return $slider.slick(sliderSettings);
            }
        }

        
        
    }

    trigger_slick_on_mobile(slider, settings, breakpoint) {
        $(window).on('resize', function () {
            if ($(window).width() > breakpoint) {
                if (slider.hasClass('slick-initialized')) {
                    slider.slick('unslick');
                }
                return;
            }
            if (!slider.hasClass('slick-initialized')) {
                return slider.slick(settings);
            }
        });
    }

    
}

class ComparisonSlider {
    constructor(selector, element) {
        this.all = element.querySelectorAll(selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }
    
    render(el, index) {
        new ComparisonSliderItem(el, index);
    }
}

export default ComparisonSlider;